/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestSmsResponse
 */
export interface TestSmsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TestSmsResponse
     */
    success: boolean;
}

/**
 * Check if a given object implements the TestSmsResponse interface.
 */
export function instanceOfTestSmsResponse(value: object): value is TestSmsResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function TestSmsResponseFromJSON(json: any): TestSmsResponse {
    return TestSmsResponseFromJSONTyped(json, false);
}

export function TestSmsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestSmsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
    };
}

export function TestSmsResponseToJSON(json: any): TestSmsResponse {
    return TestSmsResponseToJSONTyped(json, false);
}

export function TestSmsResponseToJSONTyped(value?: TestSmsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

